import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

// Dealer-photo host from the `ddc-account-assets` <Foo>Keeper endpoint; '' until seeded.
export const initialState = '';

const dealerPhotoSlice = createSlice({
	name: 'dealerPhoto',
	initialState,
	reducers: {
		dealerPhotoBaseUrlAdded(_state, action) {
			return action.payload;
		}
	}
});

export const useDealerPhotoBaseUrl = () =>
	useSelector((state) => state.dealerPhoto || '');

export const { dealerPhotoBaseUrlAdded } = dealerPhotoSlice.actions;

export default dealerPhotoSlice.reducer;
